import { defineComponent as _defineComponent } from 'vue'
import { Icon, Picture, Spinner, Typo } from '@travelata-libs/ui-kit';
  import { setBodyOverflow, useViewport } from '@travelata-libs/utils';
  import { onBeforeUnmount, onMounted } from 'vue';
  import Teleport from 'vue2-teleport'; // eslint-disable-line @typescript-eslint/no-unused-vars
  import { PROVIDERS_MODAL_Z_INDEX } from '../config';
  import { getProviderLogo } from '../lib/getProviderLogo';
  import type { ProviderOfferData } from '../model/types';

  interface PartnerRedirectScreenProps {
    offer: ProviderOfferData;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerRedirectScreen',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: ProviderOfferData;
  }

  

  const { isMobile } = useViewport();

  const REDIRECT_DELAY_MS = 2500;

  let redirectTimer: ReturnType<typeof setTimeout> | null = null;

  onMounted(() => {
    setBodyOverflow('hidden');
    redirectTimer = setTimeout(() => {
      if (props.offer.redirectUrl) {
        window.location.replace(props.offer.redirectUrl);
      }
    }, REDIRECT_DELAY_MS);
  });

  onBeforeUnmount(() => {
    setBodyOverflow('visible');
    if (redirectTimer) clearTimeout(redirectTimer);
  });

return { __sfc: true,props, isMobile, REDIRECT_DELAY_MS, redirectTimer, Icon, Picture, Spinner, Typo, Teleport, PROVIDERS_MODAL_Z_INDEX, getProviderLogo }
}

})